export function getCssVarRgb(name: string, fallback: string, alpha?: number) {
  if (typeof window === 'undefined') return fallback

  const value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  if (!value) return fallback

  if (alpha === undefined) return `rgb(${value})`
  return `rgba(${value.replace(/\s+/g, ', ')}, ${alpha})`
}
